import { Asset, AssetType } from '@/api/generatedApi';
import { getFileExtension } from '@physna/supported-files';

export type Model = Asset & {
  type: AssetType.Model;
};

export type Image = Asset & {
  type: AssetType.Image;
};

export type Document = Asset & {
  type: AssetType.Document;
};

export const isModel = (asset?: Asset): asset is Model => {
  return asset?.type === AssetType.Model;
};

export const isImage = (asset?: Asset): asset is Image => {
  return asset?.type === AssetType.Image;
};

export const isDocument = (asset?: Asset): asset is Document => {
  return asset?.type === AssetType.Document;
};

export const isPDFDocument = (asset?: Asset): asset is Document => {
  return asset?.type === AssetType.Document && getFileExtension(asset?.path || '').toLowerCase() === '.pdf';
};
